import React from 'react'

export const PrintParkingComponent = ({ reserve }) => {
    return (
        <div>
            {Array.from({ length: reserve.parking ? reserve.parking.count:0 }).map((_, index) => (

                <div >
                    <table className="reserve-info-table">
                        <thead>
                            <tr>
                                <td> <span className='bold'>شماره پذیرش : {reserve.trackingCode}</span></td>
                                <td>  <span className='bold'>{reserve.objectInstance.title} </span></td>
                                <td><span className='bold'>مدت: </span> <span>{reserve.factor.nightCount} شب</span></td>
                            </tr>
                        </thead>

                        <tbody>
                            <tr >
                                <td><span className='bold'>نام و نام خانوادگی : </span> <span>{reserve.fullName}</span></td>
                                <td><span className='bold'>شماره همراه: </span> <span>{reserve.mobile}</span></td>
                                <td><span className='bold'>تاریخ ورود: </span>
                                    <span> <span>{reserve.from_Shamsi_DayOfWeek} </span>
                                        <div style={{ display: 'inline' }} >{reserve.from_Shamsi}</div></span>
                                </td>
                            </tr>

                            <tr >
                                <td><span className='bold'>تعداد کل پارکینگ: </span> <span>{reserve?.parking?.count}</span></td>
                                <td><span className='bold'>نوع/پلاک ماشین </span> <span>{index + 1} :</span></td>
                                <td><span className='bold'>تاریخ خروج: </span>
                                    <span>{reserve.to_Shamsi_DayOfWeek} </span>
                                    <div style={{ display: 'inline' }} >{reserve.to_Shamsi}</div>
                                </td>
                            </tr>

                            <tr >
                                <td><span className='bold'>محل پارک:</span></td>
                                <td><span className='bold'>فی (هر شب) : </span><span>{(reserve?.parking?.price ).toLocaleString()} ریال</span></td>
                                <td><span className='bold'>مبلغ کل : </span><span>{(reserve?.parking?.count * reserve?.parking?.price * reserve?.factor?.nightCount).toLocaleString()} ریال</span></td>
                            </tr>
                            <tr>
                                <td colSpan={3}><span className='bold'>توضیحات: </span></td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <div className="table-container">
                        <table className="food-table">
                            <thead>
                                <tr>
                                    <th>امضا متقاضی</th>
                                    <th>مهر و امضا مسئول امور مالی</th>
                                    <th>مهر و امضا مسئول پارکینگ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr >
                                <td><br /><br /></td>
                                <td><br /><br /></td>
                                <td><br /><br /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    )
}

